module.exports = __webpack_public_path__ + "img/DataTable.e1eb6b4d.svg";